import React from 'react';
import { Link } from 'react-router-dom';
import { handleLogin } from '../services/handleLogin';

const Login = () => {
  const accessToken = localStorage.getItem('accessToken');

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    window.location.reload(); // Reload the page to clear the logged-in state
  };

  if (accessToken) {
    return (
      <div className="flex flex-col items-center justify-center h-full bg-slate-800 p-6 rounded-lg shadow-lg shadow-black">
        <h2 className="text-2xl text-slate-100 font-bold mb-4">You're already logged in</h2>
        <Link
          to="/dashboard"
          className="bg-emerald-600 hover:bg-emerald-400 text-white font-semibold px-4 py-2 rounded"
        >
          Proceed
        </Link>
        <button
          onClick={handleLogout}
          className="bg-red-600 hover:bg-red-400 text-white font-semibold px-4 py-2 rounded mt-4"
        >
          Log Out
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center text-slate-100 justify-center h-full bg-slate-800 p-6 rounded-lg shadow-lg shadow-black">
      <h2 className="text-2xl font-bold mb-4">Login</h2>
      <button
        onClick={handleLogin}
        className="bg-emerald-600 hover:bg-emerald-400 text-white font-semibold px-4 py-2 rounded"
      >
        Go to Pike13
      </button>
    </div>
  );
};

export default Login;
